import { FC } from 'react'
import { ITableThead } from './Table'

const TableThead: FC<ITableThead> = ({
  thead,
  isPending = false,
  className = '',
  size = 'medium',
  pagable,
  onSort,
}) => (
  <thead className={`z-0 relative ${className}`}>
    <tr>
      {thead.map(({ title = '', sortCol, align }, i) => (
        <th
          key={`head-${title}-${sortCol}-${i}`}
          scope='col'
          className={`
              ${/*sticky*/ ``}  
              top-0 z-50 border-b bg-gray-100 border-gray-300 font-semibold text-left
              ${
                {
                  small: 'py-3 text-sm',
                  medium: 'py-3.5',
                }[size]
              }
              ${sortCol && !isPending ? 'cursor-pointer' : ''}
            `}
          // style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.7)'}}
          onClick={() => {
            if (isPending || !sortCol) return
            onSort && onSort(sortCol)
          }}
        >
          <div
            className={`
              flex items-center gap-[2px] [&>svg]:h-[1.2em]
              ${
                {
                  left: 'justify-start pl-2',
                  center: 'justify-center',
                  right: 'justify-end pr-2',
                }[align || 'left']
              }
            `}
          >
            <div className='whitespace-nowrap'>{title}</div>
            {sortCol &&
              pagable?.sort === sortCol &&
              (pagable?.sortDirection === 'asc' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='m5 12 7-7 7 7' />
                  <path d='M12 19V5' />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M12 5v14' />
                  <path d='m19 12-7 7-7-7' />
                </svg>
              ))}
          </div>
        </th>
      ))}
    </tr>
  </thead>
)

export default TableThead
